import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { CommonService } from '../services/common.service';
import { inject } from '@angular/core';
import { ONBOARDING_STEPS } from '../after-login/pages/onboarding-shell-component/steps.config';

export const onboardingGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const commonService: CommonService = inject(CommonService);
  const router = inject(Router);

  const steps = ONBOARDING_STEPS.map(s => s.key);
  const targetStep = route.routeConfig?.path;
  const targetIndex = steps.findIndex(s => s === targetStep);

  // if target step > allowed index → redirect to allowed step instead of false
  if (targetIndex > commonService.maxAllowedStepIndex()) {
    const allowedStep = steps[commonService.maxAllowedStepIndex()];
    return router.createUrlTree([`/onboarding/${allowedStep}`]);
  }

  return true;
};
